import React from 'react'

const ChartCard = ({ title, subtitle, children, empty }) => {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
        <div className="mb-3">
            <h3 className="text-[13px] font-semibold text-gray-900">{title}</h3>
            {subtitle && <p className="text-[11px] text-gray-400">{subtitle}</p>}
        </div>
        {empty ? (
            <div className="flex h-[240px] items-center justify-center text-[12px] text-gray-400">
                Not enough data yet.
            </div>
        ) : (
            children
        )}
    </div>
  )
}

export default ChartCard